export function singlePropertyLookupTypeGuard(value) {
    return value && value['option'] && value['property'];
}
export function multiPropertiesLookupRecordTypeGuard(value) {
    return value && value['option'] && value['properties'] && !value['key'];
}
export function extendedSinglePropertyLookupTypeGuard(value) {
    return value && value['option'] && value['key'] && value['properties'];
}
export function oneOptionLookupRecordTypeGuard(value) {
    return singlePropertyLookupTypeGuard(value) || multiPropertiesLookupRecordTypeGuard(value) || extendedSinglePropertyLookupTypeGuard(value);
}
//# sourceMappingURL=ResolutionSchemaDefinition.js.map